import { Form, FormElement } from '@progress/kendo-react-form';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import CustomModal from 'commons/modal/CustomModal';
import FormFooterWithAccess from 'commons/modal/FormFooterWithAccess';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import FormControls from '../controls/FormControls';
import { FORMATSPAGE } from '../constants/types';
import { useGetDiffuseursQuery, useGetMagasinsQuery, useGetReseauxQuery, useGetTypeEnvoiInstructionsQuery } from '../../../redux/api/cache';

export default function AddParameterModal(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const { data: storesDropdown } = useGetMagasinsQuery();
  const { data: typeEnvoie } = useGetTypeEnvoiInstructionsQuery();
  const { data: diffuseurs } = useGetDiffuseursQuery();
  const { data: reseaux } = useGetReseauxQuery();

  const handleSubmit = (dataItem) => {
    Object.keys(dataItem).forEach((key) => {
      if (key === 'mag_num_lst')
        dataItem[key] = dataItem[key]?.map((setStore) => storesDropdown?.data?.find((store) => store.mag_nom === setStore).mag_num).join(',');

      if (key === 'four_cd')
        dataItem[key] = dataItem[key].split('(').pop().slice(0, -1);

      if (key === 'diff_envoi_instruct')
        dataItem[key] = typeEnvoie?.data?.find((type) => type.typeEnvoi === dataItem[key])?.valEnvoi;

      if (key === 'media_cd' && props.name === 'Diffuseurs')
        dataItem[key] = dataItem[key].join(',');

      if (key === 'res_cd' && props.name === 'Diffuseurs') {
        dataItem[key] = reseaux?.data?.find((reseau) => reseau.res_descr === dataItem[key])?.res_cd;
      }

      if (key === 'diff_cd' && props.id === FORMATSPAGE) {
        dataItem[key] = diffuseurs?.data?.find(d => d.diff_nom === dataItem[key])?.diff_cd;
      }
    });

    props.save(dataItem);
    props.toggleDialog();
  };

  const getStoresValues = (values) => {
    if (storesDropdown?.data !== undefined && values)
      return values.split(',')?.map((mag) =>
        storesDropdown.data.find((store) => String(store.mag_num) === mag)
          ?.mag_nom
      );
  };

  const getInitialValues = () => {
    let initialValuesForm = {};

    var row = props.rowData;

    props.definition.forEach((item) => {
      if (item.key !== 'nom_four' && item.key !== 'adr_four')
        switch (item.key) {
          case 'mag_num_lst':
            initialValuesForm[item.key] = getStoresValues(row[item.key]);
            break;
          case 'diff_envoi_instruct':
            initialValuesForm[item.key] = typeEnvoie?.data?.find(
              (type) => type.valEnvoi === row[item.key]
            )?.typeEnvoi;
            break;
          case 'media_cd':
            if (props.name === 'Diffuseurs')
              initialValuesForm[item.key] = row[item.key] ? row[item.key]?.split(',') : undefined;
            else
              initialValuesForm[item.key] = row[item.key];
            break;
          case 'res_cd':
            if (props.name === 'Diffuseurs')
              initialValuesForm[item.key] = reseaux?.data?.find((reseau) => reseau.res_cd === row[item.key])?.res_descr;
            else
              initialValuesForm[item.key] = row[item.key];
            break;
          case 'diff_cd':
            if (props.id === FORMATSPAGE) {
              initialValuesForm[item.key] = diffuseurs?.data?.find((diffuseur) => diffuseur.diff_cd === row[item.key])?.diff_nom;
            } else {
              initialValuesForm[item.key] = row[item.key];
            }
            break;
          case 'diff_statut':
            initialValuesForm[item.key] = props.modification ? row[item.key] : true;
            break;
          default:
            initialValuesForm[item.key] = row[item.key];
            break;
        }
    });

    return initialValuesForm;
  };

  const getForm = useMemo(() => {
    return Object.keys(props.rowData).filter(key => key !== "nom_four" && key !== "adr_four").map((key, i) => {
      const definition = props.definition.find((def) => def.key === key);
      return <div className="col-md-6" key={i}><FormControls id={props.id} defKey={key} label={definition?.label} title={props.name} firstCol={props.firstCol} form={props.form} modification={props.modification} data={props.data} rowData={props.rowData} /></div>;
    });
  }, [props.rowData, props.definition, props.id, props.name, props.firstCol, props.form]);

  return (
    <div>
      <CustomModal
        title={props.title}
        onClose={props.toggleDialog}
        body={
          <Form
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
              <FormElement>
                <fieldset className={'k-form-fieldset'}>
                  <div className="row">
                    {getForm}
                  </div>
                  <FormFooterWithAccess
                    selectedRow={props.form ? undefined : props.rowData}
                    formRenderProps={formRenderProps}
                    delete={() => setDeleteModalVisible(!deleteModalVisible)}
                  />
                </fieldset>
              </FormElement>
            )}
          />
        }
      />
      {deleteModalVisible && (
        <ConfirmationModal
          text={`Confirmer la suppression ?`}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          onConfirm={() => {
            setDeleteModalVisible(false);
            props.toggleDialog();
            if (props.id === FORMATSPAGE)
              props.removeRow(props.rowData[props.firstCol], props.rowData["media_cd"], props.rowData["diff_cd"]);
            else
              props.removeRow(props.rowData[props.firstCol]);
          }}
        />
      )}
    </div>
  );
}

AddParameterModal.propTypes = {
  modification: PropTypes.bool,
  definition: PropTypes.array,
  firstCol: PropTypes.any,
  form: PropTypes.any,
  removeRow: PropTypes.func,
  save: PropTypes.func,
  title: PropTypes.string,
  toggleDialog: PropTypes.func,
  rowData: PropTypes.any,
  id: PropTypes.string,
  name: PropTypes.string,
  data: PropTypes.any
};
